import AnimatedHeading, { headingVariants } from './AnimatedHeading';

export { headingVariants };

export default AnimatedHeading;
